import angular from 'angular';

angular
  .module('cxRelations')
  .controller('RelationFileCtrl', ['relBindSvc', '$state', relationFileCtrl]);

function relationFileCtrl(relBindSvc, $state) {
  var vm = this;
  
  vm.$onInit = function() {
    vm.relations = relBindSvc.relations;
    vm.current = relBindSvc.active;
    vm.relationId = $state.params.relId || relBindSvc.active.id;

    if ($state.params.relId) {
      vm.relationId = $state.params.relId;
    } else if (relBindSvc.active.id) {
      vm.relationId = relBindSvc.active.id;
    }

    if (!vm.relationId) {
      $state.go('relations.overview');
    }
    if (
      !vm.relations[vm.relationId] ||
      (!vm.relations[vm.relationId].sections && !vm.relations[vm.relationId].loading) ||
      (!$state.params.fromRelBindSvc && !vm.relations[vm.relationId].loading)
    )
      relBindSvc.open(vm.relationId);
  };
}
